<template>
	<div>
		<ComNar title="选择门店"></ComNar>
		<div class="search-div">
			<span style="width: 1.8rem;"  @click="toLocation()"><van-icon name="location"></van-icon>手动定位</span>
			<van-search v-model="searchName" shape="round" show-action placeholder="请输入搜索关键词" @search="doSearch()">
				<template #left-icon>
					<div class="city-select-button" @click="toLocation()">
						<span>{{ sCity ? sCity : '选择城市' }}</span>
						<van-icon name="arrow-down" color="#9a9a9a" />
					</div>
				</template>
				<template #action>
					<div class="search-button" @click="doSearch()">搜索</div>
				</template>
			</van-search>
		</div>
		<div id="amap" style="display: none;"></div>
	</div>
</template>

<script>
import ComNar from './ComNar.vue'
import { Search, Icon, Notify } from 'vant';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { Loader } from './AMapLoader'
export default {
	name: 'ComSearch',
	computed: mapGetters(["sLocation", "sCity"]),
	components: {
		[ComNar.name]: ComNar,
		[Icon.name]: Icon,
		[Search.name]: Search,
		[Notify.name]: Notify
	},

	data() {
		return {
			searchName: '',
			city: "",
			lat: null,
			lng: null,
			adcode: "",
			amap: null
		}
	},
	
	created() {
		//查询定位信息
		// console.log(this.sLocation, this.sCity,'comSearch');
		if (!this.sLocation.lat) {
			this.getTxlocation();
		}
		if (!this.sCity) {
			this.cityGeo();
		}
	},
		
	methods: {
		...mapMutations(['sSetLocation']),
		getTxlocation() {
			Loader("amap", this.successPosition, this.errPosition, 2).then((AMap) => {
				this.amap = AMap
			}).catch((e) => {
				console.log(e);
			})

		},
		cityGeo() {
			if (!this.amap) {
				Loader("amap",(e,r)=>{
					if (e == "complete") {
							if (r.info == "OK") {
								if (!this.lat) {
									this.lat = parseFloat((r.bounds.northEast.lat + r.bounds.southWest.lat) / 2).toFixed(6)
									this.lng = parseFloat((r.bounds.northEast.lng + r.bounds.southWest.lng) / 2).toFixed(6)
								}
								this.city = r.city
								if (this.city != this.sCity) {
									this.getTxlocation()
								}
								this.adcode = r.adcode
								this.$emit('changePosition', [this.lat, this.lng, this.city])
								this.addLocation(this.city, this.lat, this.lng, this.adcode);
							}
						}
				},(e,r)=>{

				},1)
			} else {
				this.amap.plugin("AMap.CitySearch", () => {
					let city = new this.amap.CitySearch();
					city.getLocalCity((e, r) => {
						// console.log(e, r);
						if (e == "complete") {
							if (r.info == "OK") {
								if (!this.lat) {
									this.lat = parseFloat((r.bounds.northEast.lat + r.bounds.southWest.lat) / 2).toFixed(6)
									this.lng = parseFloat((r.bounds.northEast.lng + r.bounds.southWest.lng) / 2).toFixed(6)
								}
								this.city = r.city
								if (this.city != this.sCity) {
									this.getTxlocation()
								}
								this.adcode = r.adcode
								this.$emit('changePosition', [this.lat, this.lng, this.city])
								this.addLocation(this.city, this.lat, this.lng, this.adcode);
							}
						}
					}, (e, r) => {

					});
				});
			}
		},
		successPosition(e, res) {
			// console.log(e, res);
			if (e == "complete") {
				if (res.position) {
					this.lat = res.position.lat
					this.lng = res.position.lng
					if (!this.city) {
						this.cityGeo()
					}
				}

			} else {
				this.cityGeo()
			}
			// if (this.city && this.lat && this.lng && this.adcode) {
			// 	this.addLocation(this.city, this.lat, this.lng, this.adcode);
			// 	this.$emit('changePosition')
			// }
		},
		errPosition(e) {
			// console.log(e);
			this.cityGeo()
			// var geolocation = new qq.maps.Geolocation();
			// var options = { timeout: 6000 };
			// geolocation.getIpLocation(this.successPosition, this.stopGetLocation, options)
		},
		addLocation(city, lat, lng, adcode) {
			this.sSetLocation({
				'city': city,
				'lat': lat,
				'lng': lng,
				'adcode': adcode
			});
		},
		stopGetLocation() {
			Notify({ type: 'danger', message: '定位失败' });
			this.toLocation()

		},
		doSearch() {
			this.$emit('doSearch', this.searchName)
		},
		toLocation() {
			this.$router.push("location");
		}


	}
}
</script>

<style scoped>
.search-div{
	padding: 0 0.3rem;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #fff;
}
.city-select-button {
	background-color: #f7f8fa;
	height: 25px;
	padding-right: 10px;
}

.city-select-button>span {
	line-height: 25px;
	font-size: 15px;
}

.city-select-button>i {
	margin-left: 5px;
	display: inline !important;
}

.search-button {
	font-size: 15px;
}

.van-ellipsis {
	font-size: 13px;
}

.van-field__control {
	font-size: 13px;
}
.van-search{
	padding: 0.3rem 0 !important;
}
</style>
